// extracted by mini-css-extract-plugin
module.exports = {"main":"about-module--main--FNeYd","title":"about-module--title--1pGbt"};